import axiosRequest from '.';

const getAllExpenseTypes = async () => (
  axiosRequest({
    url: '/v1/expenseType/findAll',
    method: 'POST',
  })
);

const createExpenseTypes = async (data) => (
  axiosRequest({
    url: '/v1/expenseType/create',
    method: 'POST',
    data,
  })
);

export {
  getAllExpenseTypes,
  createExpenseTypes,
};
